var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedWarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF6960"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 45.3327C39.3332 45.3327 45.3332 39.3327 45.3332 31.9993C45.3332 24.666 39.3332 18.666 31.9998 18.666C24.6665 18.666 18.6665 24.666 18.6665 31.9993C18.6665 39.3327 24.6665 45.3327 31.9998 45.3327Z",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.666V33.3327",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9927 37.334H32.0047",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarnIcon);
export default __webpack_public_path__ + "static/media/redWarnIcon.fc332a81e303102eddea070a6fa564dd.svg";
export { ForwardRef as ReactComponent };